export const REGEX = {
  EMAIL: /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$/,
  PASSWORD: /^[a-zA-Z0-9#?!@$ %^&*-]{6,32}$/
}
